/* eslint-disable camelcase -- Stream Chat attachment fields use snake_case */
import { FC, useMemo } from 'react';
import { Attachment, AttachmentProps, DefaultStreamChatGenerics } from 'stream-chat-react';
import { getAttachmentDisplayName } from 'shared/components/Attachments/attachmentUtils';
import CustomCard from '../CustomCard/CustomCard';
import CustomImage from '../CustomImage/CustomImage';
import CustomFileAttachment from './CustomFileAttachment';

const CustomAttachment: FC<AttachmentProps<DefaultStreamChatGenerics>> = props => {
	const normalizedAttachments = useMemo(() => {
		return props.attachments?.map(attachment => {
			const targetUrl =
				attachment.asset_url ||
				attachment.image_url ||
				attachment.title_link ||
				(attachment as unknown as Record<string, string>).url ||
				'';
			const rawTitle =
				attachment.title || (attachment as unknown as Record<string, string>).name || targetUrl || '';

			// Normalize all message file attachments (documents, spreadsheets, pdfs, images, videos, etc.) to 'file'
			// so they render uniformly through CustomFileAttachment with matching width and seamless grouping.
			if (!attachment.og_scrape_url && attachment.type !== 'giphy') {
				const resolvedTitle = rawTitle
					? getAttachmentDisplayName(rawTitle)
					: getAttachmentDisplayName(targetUrl);
				return {
					...attachment,
					type: 'file',
					asset_url: targetUrl || rawTitle,
					title: resolvedTitle,
				};
			}

			return attachment;
		});
	}, [props.attachments]);

	return (
		<Attachment
			{...props}
			attachments={normalizedAttachments}
			Card={CustomCard}
			Image={CustomImage}
			File={CustomFileAttachment}
			UnsupportedAttachment={CustomFileAttachment}
		/>
	);
};

export default CustomAttachment;
